<template>

<table class="order-contents">
  <thead>
    <tr>
      <th>Naziv</th>
      <th>Cena</th>
      <th>PDV</th>
      <th>Bruto cena</th>
      <th>Količina</th>
    </tr>
  </thead>
  <tbody>
    <template v-for="orderItem in modelValue || []">
      <tr v-if="orderItem.type=='Delivery'">
        <td>{{ orderItem.name }}</td>
        <td></td>
        <td></td>
        <td>{{ orderItem.applied.shippingPrice }}</td>
        <td></td>
      </tr>
      <tr v-else>
        <td>{{ orderItem.product.title }}</td>
        <td></td>
        <td></td>
        <td>{{ productPrice(orderItem) }}</td>
        <td>{{ orderItem.quantity }}</td>
      </tr>
    </template>
  </tbody>
  <tfoot>
    <tr>
      <th>Ukupno</th>
      <td></td>
      <td></td>
      <td>{{ totalPrice }}</td>
      <td></td>
    </tr>
  </tfoot>
</table>

</template>

<script>
export default {
  props: {
    dbfield: {},
    field: {},
    item: {},
    modelValue: {},
  },
  methods: {
    productPrice(orderItem) {
      var price=(orderItem.product.salePrice || orderItem.product.price)*1;
      for(var discounted of orderItem.discounts || [])
        if (discounted[1]*1<price)
          price=discounted[1]*1;
      return price;
    },
  },
  computed: {
    totalPrice() {
      return (this.modelValue || []).reduce((acc, item)=>{
        var price=null;
        if (item.type=="Delivery")
          price=item.applied.shippingPrice*1;
        else
          price=this.productPrice(item);
        return acc+price;
      }, 0).toFixed(2);
    }
  }
}
</script>
